module.exports = __webpack_public_path__ + "img/ico-new-request.602ba901.svg";